export default __webpack_public_path__ + "static/pay_compare_comp3_inactive-fabd23b9a579ec171555387c36754c24.png";